module.exports = __webpack_public_path__ + "static/image/service/pc/mart.jpg?72a94b81";